import api from './api';

const checkRedeemCode = async (code) => {
  const encodedCode = encodeURIComponent(code);
  const response = await api({
    method: 'GET',
    url: `/redeem-codes/${encodedCode}/check`,
  });

  return response;
};

export { checkRedeemCode };
